import React, { FormEvent, ChangeEvent } from "react";

import withTitle from "../withTitle";
import ExpandList, { ExpandListEvent } from "../ExpandList";
import { V1, V2 } from "../../Api";
import { DateTime } from "luxon";
import { Link } from "react-router-dom";
import { RouteComponentPropsHistory } from "../../types";
import { formatDateLocal } from "../../Utilities";

interface IEmailOutreachViewState {
    isLoading: boolean | string;
    resultCount: number | undefined;

    questions: any[];

    dateStart: string;
    dateEnd: string;

    sex: string;

    ageMin: string;
    ageMax: string;

    fairId: string;
    fair?: any;

    selectedYesQuestions: any[];
    selectedNoQuestions: any[];
}

class EmailOutreachView extends React.Component<RouteComponentPropsHistory<any, any>, IEmailOutreachViewState> {
    constructor(props: Readonly<RouteComponentPropsHistory<any, any>>) {
        super(props);

        const state: IEmailOutreachViewState = {
            isLoading: false,
            resultCount: undefined,

            questions: [],

            dateStart: "",
            dateEnd: "",

            sex: "",

            ageMin: "",
            ageMax: "",

            fairId: "",

            selectedYesQuestions: [],
            selectedNoQuestions: [],
        };

        this.state = state;

        this.applySettings(props.location.state, true);


        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.search = this.search.bind(this);
        this.questionYesAdd = this.questionYesAdd.bind(this);
        this.questionYesRemove = this.questionYesRemove.bind(this);
        this.questionNoAdd = this.questionNoAdd.bind(this);
        this.questionNoRemove = this.questionNoRemove.bind(this);
        this.beginFairSelection = this.beginFairSelection.bind(this);
        this.removeFairSelection = this.removeFairSelection.bind(this);
    }

    public componentDidMount() {
        this.loadBaseData();
    }

    public render() {
        return (
            <div className="viewer-root">
                <form className="input-form" onSubmit={this.search}>
                    <div className="column-root">
                        <section className="info-block">
                            <header>
                                <h2>Filters</h2>
                            </header>

                            <section>
                                <div className="input-form-group">
                                    <label htmlFor="frm-date-start" className={!this.state.fairId ? "required" : ""}>Start Date</label>
                                    <input type="date" id="frm-date-start" name="dateStart" value={this.state.dateStart} onChange={this.handleInputChanged} />
                                </div>
                                <div className="input-form-group">
                                    <label htmlFor="frm-date-end" className={!this.state.fairId ? "required" : ""}>End Date</label>
                                    <input type="date" id="frm-date-end" name="dateEnd" value={this.state.dateEnd} onChange={this.handleInputChanged} />
                                </div>
                            </section>

                            <section>
                                <div className="input-form-group">
                                    <label htmlFor="frm-age-min" className="">Patient Minimum Age</label>
                                    <input type="number" id="frm-age-min" name="ageMin" value={this.state.ageMin} min={1} onChange={this.handleInputChanged} />
                                </div>
                                <div className="input-form-group">
                                    <label htmlFor="frm-age-max" className="">Patient Maximum Age</label>
                                    <input type="number" id="frm-age-max" name="ageMax" value={this.state.ageMax} min={1} onChange={this.handleInputChanged} />
                                </div>
                            </section>

                            <section>
                                <div className="input-form-group">
                                    <label htmlFor="frm-sex" className="">Sex</label>
                                    <select id="frm-sex" name="sex" value={this.state.sex} onChange={this.handleInputChanged}>
                                        <option value="">Any</option>
                                        <option value="F">Female</option>
                                        <option value="M">Male</option>
                                    </select>
                                </div>
                                <div className="input-form-group" />
                            </section>

                            <section>
                                <div className="input-form-group">
                                    <label htmlFor="frm-fair" className="">Health Fair</label>
                                    {this.state.fair
                                        ? <>
                                            <div>{this.state.fair.name} on {formatDateLocal(this.state.fair.scheduledDate)} <button type="button" className="button btn-inline red" onClick={this.removeFairSelection}>De-select fair</button></div>
                                        </>
                                        : this.state.fairId
                                            ? <div>Loading selected fair...</div>
                                            : <div><button type="button" className="button" onClick={this.beginFairSelection}>Select fair...</button></div>}
                                </div>
                            </section>
                        </section>
                        <section className="info-block">
                            <header>
                                <h2>Question Filters</h2>
                            </header>
                            <p>
                                You can filter surveys based on whether questions were answered yes or no
                            </p>

                            <p>Answered <b>Yes</b> to all of:</p>

                            <ExpandList items={this.state.selectedYesQuestions} itemRender={this.questionItemRender} itemIdField="id" options={this.state.questions} optionRender={this.questionOptionRender} onAdd={this.questionYesAdd} onDelete={this.questionYesRemove} autoAdd={true} />
                            <hr />

                            <p>Answered <b>No</b> to all of:</p>

                            <ExpandList items={this.state.selectedNoQuestions} itemRender={this.questionItemRender} itemIdField="id" options={this.state.questions} optionRender={this.questionOptionRender} onAdd={this.questionNoAdd} onDelete={this.questionNoRemove} autoAdd={true} />
                        </section>
                    </div>
                    &nbsp;
                    <div className="action-panel-dialog">
                        <span className="spring" />
                        <button type="submit" className="button">Search</button>
                    </div>

                    {this.state.isLoading === true
                        ? <div className="spinner lds-dual-ring" />
                        : typeof this.state.isLoading === "string"
                            ? <span className="error-text">{this.state.isLoading}</span>
                            : this.state.resultCount !== undefined
                                ? <>
                                    <div>Search returned {this.state.resultCount} result(s)</div>
                                    &nbsp;
                                    {this.state.resultCount > 0
                                        ? <div className="action-panel-dialog">
                                            <Link to={{ pathname: "/email-outreach/results", state: { settings: this.getSettings() } }} className="button">View Results</Link>
                                        </div>
                                        : null}
                                </>
                                : null
                    }
                </form>
            </div>
        );
    }

    private questionOptionRender(q: any) {
        return q.text || "";
    }

    private questionItemRender(item: any) {
        return item.text || "";
    }

    private questionYesAdd(evt: ExpandListEvent<any>) {
        this.setState(s => {
            s.selectedYesQuestions.push(evt.item);

            return s;
        });
    }

    private questionYesRemove(evt: ExpandListEvent<any>) {
        this.setState(s => {
            s.selectedYesQuestions.splice(evt.index!, 1);

            return s;
        });
    }

    private questionNoAdd(evt: ExpandListEvent<any>) {
        this.setState(s => {
            s.selectedNoQuestions.push(evt.item);

            return s;
        });
    }

    private questionNoRemove(evt: ExpandListEvent<any>) {
        this.setState(s => {
            s.selectedNoQuestions.splice(evt.index!, 1);

            return s;
        });
    }

    private async search(e: FormEvent) {
        e.preventDefault();

        if (!this.state.fairId && (!this.state.dateStart || !this.state.dateEnd)) {
            return;
        }

        this.saveSettings();

        const query = {
            dateStart: this.state.dateStart ? DateTime.fromISO(this.state.dateStart).startOf("day").toISO() : undefined,
            dateEnd: this.state.dateEnd ? DateTime.fromISO(this.state.dateEnd).endOf("day").toISO() : undefined,

            ageMin: !parseInt(this.state.ageMin) ? undefined : parseInt(this.state.ageMin),
            ageMax: !parseInt(this.state.ageMax) ? undefined : parseInt(this.state.ageMax),

            sex: (this.state.sex || null)?.toUpperCase(),

            questionsYes: this.state.selectedYesQuestions.map(a => a.id),
            questionsNo: this.state.selectedNoQuestions.map(a => a.id),

            fairId: this.state.fairId || undefined,
        };

        try {
            this.setState({
                isLoading: true
            });

            const result = await V2.post<any>("survey/query", query);

            this.setState({
                isLoading: false,
                resultCount: result.count
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not execute request"
            });
        }
    }

    private handleInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement> | ChangeEvent<HTMLSelectElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;

        this.setState({
            [name]: value
        } as any);
    }

    private async loadBaseData() {
        try {
            const questions = await V2.get<any[]>("survey-types/questions");

            this.setState({
                questions
            });

            if (this.state.fairId) {
                const fair = await V1.get<any>(`fairs/${this.state.fairId}`);

                this.setState({
                    fair
                });
            }
        }
        catch (e) {

        }
    }

    private saveSettings() {
        const location = this.props.location;

        location.state = this.getSettings();

        this.props.history.replace(location);
    }

    private getSettings() {
        return {
            dateStart: this.state.dateStart,
            dateEnd: this.state.dateEnd,

            sex: this.state.sex,

            ageMin: this.state.ageMin,
            ageMax: this.state.ageMax,

            selectedYesQuestions: this.state.selectedYesQuestions,
            selectedNoQuestions: this.state.selectedNoQuestions,

            fairId: this.state.fairId,
            fair: this.state.fair ? {
                name: this.state.fair.name,
                scheduledDate: this.state.fair.scheduledDate,
            } : undefined
        };
    }

    private applySettings(settings: any, direct = false) {
        if (!settings) {
            return;
        }

        if (direct) {
            const newState = Object.assign({}, this.state, settings);

            if (settings.selectedFairId) {
                newState.fairId = settings.selectedFairId;

                delete newState.selectedFairId;
                delete newState.selectedFairName;
            }

            // This direct mutation is fine, as it should only ever be called in the ctor
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state = newState;
        }
        else {
            this.setState(settings);
        }
    }

    private beginFairSelection() {
        this.props.history.push("/fairs/schedule", {
            selectionMode: true,
            selectionUrl: "/email-outreach",
            selectionState: this.getSettings()
        });
    }

    private removeFairSelection() {
        this.setState({
            fair: undefined,
            fairId: ""
        });
    }
}

export default withTitle("Email Outreach", EmailOutreachView);